import { useEffect, useState } from "react";
import "./LanguageToggle.css";
import i18n from "i18next";

function LanguageToggle() {
  // initialize UI state from current i18n language
  const [isChinese, setIsChinese] = useState(
    i18n.language.toLowerCase().startsWith("zh")
  );

  const toggle = () => {
    const newLang = isChinese ? "en" : "zh";

    i18n.changeLanguage(newLang); // switch app language
    localStorage.setItem("lang", newLang); // persist preference
  };

  useEffect(() => {
    // keep toggle UI synced with i18n state
    const handler = (lng) => {
      setIsChinese(lng.toLowerCase().startsWith("zh"));
    };

    i18n.on("languageChanged", handler);

    // cleanup listener on unmount
    return () => i18n.off("languageChanged", handler);
  }, []);

  return (
    <div className="lang-toggle" onClick={toggle}>
      <div className={`lang-surface ${isChinese ? "zh" : "en"}`}>
        <div className="lang en">EN</div>
        <div className="lang zh">中</div>
      </div>
    </div>
  );
}

export default LanguageToggle;